import Interpolate from "./interpolate";
import CrosshairPlugin from "./trace";

export {
  applyLockedCrosshairAtNativeX,
  applyMarkerAtNativeX,
  applySyncedCrosshair,
  clearSyncedCrosshair,
} from "./apply-native-x";
export default CrosshairPlugin;
export { CrosshairPlugin, Interpolate };
